import { Injectable, signal, computed } from '@angular/core';

type ThemeMode = 'light' | 'dark' | 'system';

@Injectable({
  providedIn: 'root'
})
export class HelperThemeControllerService {
  private readonly STORAGE_KEY = 'app_theme_preference';

  themeMode = signal<ThemeMode>(this.getInitialThemeMode());

  isDark = computed(() => {
    const mode = this.themeMode();
    if (mode === 'dark') return true;
    if (mode === 'light') return false;
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  constructor() {
    this.applyTheme(this.isDark());

    if (window.matchMedia) {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
        if (this.themeMode() === 'system') {
          this.applyTheme(this.isDark());
        }
      });
    }
  }

  private getInitialThemeMode(): ThemeMode {
    const saved = localStorage.getItem(this.STORAGE_KEY) as ThemeMode;
    if (saved && ['light', 'dark', 'system'].includes(saved)) {
      return saved;
    }
    return 'system';
  }

  setThemeMode(mode: ThemeMode): void {
    this.themeMode.set(mode);
    localStorage.setItem(this.STORAGE_KEY, mode);
    this.applyTheme(this.isDark());
  }

  toggleTheme(): void {
    const nextMode: ThemeMode = this.isDark() ? 'light' : 'dark';
    this.setThemeMode(nextMode);
  }

  private applyTheme(isDark: boolean): void {
    document.body.classList.toggle('ion-palette-dark', isDark);
    document.documentElement.classList.toggle('ion-palette-dark', isDark);
  }
}
